<template lang="pug">
  .partner-registration.gray-bg
    .section
      .container.has-text-centered
        .registration-form(v-if="!Object.keys(response).length")
          h3 {{ gettext('Become a partner') }}
          .tabs.is-centered
            ul
              li(:class="{ 'is-active': !profileType.sender}"): a(@click="switchTabs({name: gettext('Receiver'), sender: false})") {{ gettext('Receiver') }}
              li(:class="{ 'is-active': profileType.sender}"): a(@click="switchTabs({name: gettext('Sender'), sender: true})") {{ gettext('Sender') }}
          .employee-form
            .field.is-horizontal
              label.label {{ gettext('Profile type')+' *' }}
              .field-body
                dropdown-simple(:custom="true" :selected="profileType")
                  a.dropdown-item(@click="profileType = {name: gettext('Receiver'), sender: false}") {{ gettext('Receiver') }}
                  a.dropdown-item(@click="profileType = {name: gettext('Sender'), sender: true}") {{ gettext('Sender') }}
              label.label.is-hidden-mobile
            .field.is-horizontal
              label.label {{ gettext('Email')+' *' }}
              .field-body
                input.input(
                v-tooltip="{content: errors.server.email || errors.required, show: tooltip.email}"
                name="email"
                type="email"
                v-model="form.email"
                @blur="validateData('email')"
                :class="{'is-danger': $v.form.email.$error || tooltip.email, 'is-empty': !form.email }")
              label.label.is-hidden-mobile
            .field.is-horizontal
              label.label {{ gettext('Password')+' *' }}
              .field-body
                input.input(
                v-tooltip="{content: errors.server.password1 || errors.required, show: tooltip.password1}"
                name="password1"
                type="password"
                v-model="form.password1"
                @blur="validateData('password1')"
                :class="{'is-danger': $v.form.password1.$error, 'is-empty': !form.password1 }")
              label.label.is-hidden-mobile
            .field.is-horizontal
              label.label {{ gettext('Repeat password')+' *' }}
              .field-body
                input.input(
                v-tooltip="{content: errors.server.password2 || errors.required, show: tooltip.password2}"
                name="password2"
                type="password"
                v-model="form.password2"
                @blur="validateData('password2')"
                :class="{'is-danger': $v.form.password2.$error, 'is-empty': !form.password2  }")
              label.label.is-hidden-mobile
            .field.is-horizontal
              label.label
              .field-body
                h4 {{ gettext('Information about the company') }}
              label.label.is-hidden-mobile
            .field.is-horizontal
              label.label {{ gettext('Country')+' *' }}
              .field-body(@click="validateData('country')")
                ajax-multiselect.is-single(
                v-tooltip="{content: errors.required, show: tooltip.country}"
                v-model="form.country"
                @updated="form.region = -1"
                :labelText="gettext('Choose the country')"
                :itemName ="'name'"
                :class="{'is-danger': $v.form.country.$error, 'is-empty': !form.country }"
                :action="{method: 'receiveCountries', params:{lang: getLanguage, filters: ['for_employer_profile'], sortBy: 'name'}}",
                :multiple="false"
                :searchable="true"
                :hideSelected="true"
                :closeOnSelect="true"
                )
              label.label.is-hidden-mobile
            .field.is-horizontal
              label.label {{ gettext('Region')+' *' }}
              .field-body(@click="validateData('region')" :class="{'is-disabled': !form.country}")
                ajax-multiselect.is-single(
                v-tooltip="{content: errors.required, show: tooltip.region && form.country}"
                v-model="form.region"
                :labelText="gettext('Choose the region')"
                :itemName ="'name'"
                :class="{'is-danger': $v.form.region.$error && form.country, 'is-empty': !form.region }"
                :action="regionAction",
                :multiple="false"
                :searchable="true"
                :hideSelected="true"
                :closeOnSelect="true"
                :disabled="form.country && !form.country.id"
                :receive="form.country && form.country.id"
                )
              label.label.is-hidden-mobile
            .field.is-horizontal
              label.label {{ gettext('Registration number')+' *' }}
              .field-body
                input.input(
                v-tooltip="{content: errors.required, show: tooltip.company_reg_number}"
                name="registration-number"
                @blur="validateData('company_reg_number')"
                :class="{'is-danger': $v.form.company_reg_number.$error, 'is-empty': !form.company_reg_number }"
                v-model="form.company_reg_number")
              label.label.is-hidden-mobile
            .field.is-horizontal
              label.label {{ gettext('Company name')+' *' }}
              .field-body
                input.input(
                name="company-name"
                v-tooltip="{content: errors.required, show: tooltip.company_name}"
                @blur="validateData('company_name')"
                @input="form.company_name = validateLatinCharacter($event)"
                :placeholder="gettext('Only latin letters')"
                :class="{'is-danger': $v.form.company_name.$error, 'is-empty': !form.company_name }"
                v-model="form.company_name")
              label.label.is-hidden-mobile
            .field.is-horizontal
              label.label
              .field-body
                h4 {{ gettext('Contacts') }}
              label.label.is-hidden-mobile
            .field.is-horizontal
              label.label {{ gettext('Contact person')+' *' }}
              .field-body
                input.input(
                name="contact-person"
                v-tooltip="{content: errors.required, show: tooltip.contact_person}"
                @blur="validateData('contact_person')"
                @input="form.contact_person = validateLatinCharacter($event)"
                :placeholder="gettext('Only latin letters')"
                :class="{'is-danger': $v.form.contact_person.$error, 'is-empty': !form.contact_person }"
                v-model="form.contact_person")
              label.label.is-hidden-mobile
            .field.is-horizontal
              label.label {{ gettext('Phone number')+' *' }}
              .field-body
                v-phone-input(
                name="phone"
                :class="{'is-danger': tooltip.contact_phone, 'is-empty': !form.contact_phone }"
                @blur="validateData('contact_phone')"
                v-tooltip="{content: errors.contact_phone || errors.required, show: tooltip.contact_phone}"
                @input="validateData('contact_phone')"
                type="text"
                @onInput="form.contact_phone = $event.number"
                :phone="form.contact_phone"
                )
              label.label.is-hidden-mobile
            .field.is-horizontal
              label.label {{ gettext('Website') }}
              .field-body
                input.input(
                name="site"
                :class="{'is-danger': tooltip.contact_website}"
                v-model="form.contact_website"
                :placeholder="errors.server.contact_website ? 'Example: https://bixter.work' : ''"
                v-tooltip="{content: errors.server.contact_website, show: tooltip.contact_website}"
                )
              label.label.is-hidden-mobile
            .field.is-horizontal
              label.label
              .field-body
                input#custom-checkbox.is-checkradio.custom-checkbox(type="checkbox" v-model="agree")
                label.checkbox(for="custom-checkbox")
                  | {{ gettext('I agree to the') }} &nbsp;
                  router-link(:to="`/${getLanguage}/terms-and-conditions`" target='_blank') {{ gettext('terms and conditions') }}
              label.label.is-hidden-mobile
            .field.is-horizontal
              label.label
              .field-body
                button.main-btn.col-white.bg-red.btn-big(
                :disabled="!agree || !formIsValid || blocked"
                @click="createAccount()"
                ) {{ gettext('Create an account') }}
              label.label.is-hidden-mobile
            .social-auth.block-center(v-if="false")
              h3 {{ gettext('Or log in with social networks') }}
              .field
                .field-body.has-icon.icon-black
                  button.main-btn.bg-transparent.google
                    | {{ gettext('Use Google account') }}
                    img(src="/webapp/images/icons/google.svg")
              .field
                .field-body.has-icon.icon-black
                  button.main-btn.bg-transparent.facebook
                    | {{ gettext('Use Facebook account') }}
                    i.mdi.mdi-facebook
        .response-container(v-if="Object.keys(response).length")
          .columns
            .column
              .block-center
                h3 {{ response.success ? gettext('Thank you for registration!') :  gettext('Registration error!') }}
                h4.has-text-centered(v-if="response.success") {{ interpolate(gettext('A letter with confirmation of registration is sent to your email (%s).'), [response.verification_email_sent_to]) }}
                h4.has-text-centered(v-else) {{ gettext('An error occurred during the registration process, contact support or try registration later.') }}
                .field
                  .field-body
                    router-link.main-btn.col-white.bg-red(:to="`/${getLanguage}/`") {{ gettext('Go to the main page') }}
</template>

<script>
import Vue from 'vue'
import { gettext, interpolate } from '@/services/TranslateHandler'
import { mapGetters, mapActions } from 'vuex'
import AjaxDropdown from '@/components/ajax-dropdown'
import AjaxMultiselect from '@/components/ajax-multiselect'
import Vuelidate from 'vuelidate'
import { email, required, sameAs } from 'vuelidate/lib/validators'
import Datepicker from '@/components/datepicker'
import VPhoneInput from '@/components/v-phone-input'
import VTooltip from 'v-tooltip'
import mixin from '@/mixins'
import DropdownSimple from '@/components/dropdown-simple'

const _ = require('lodash')
const VueScrollTo = require('vue-scrollto')
const inactive = require('@/constants.json')

Vue.use(Vuelidate)
Vue.use(VueScrollTo)
Vue.use(VTooltip, {
  defaultTrigger: 'manual'
})

export default {
  name: 'PartnerRegistration',
  mixins: [
    mixin
  ],
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo})
  },
  components: {
    DropdownSimple,
    Datepicker,
    AjaxDropdown,
    AjaxMultiselect,
    VPhoneInput
  },
  data () {
    return {
      inactive: inactive,
      blocked: false,
      agree: false,
      response: {},
      tooltip: {},
      errors: {server: {}},
      profileType: {name: gettext('Sender'), sender: true},
      form: {
        country: '',
        region: '',
        email: '',
        password1: '',
        password2: '',
        company_reg_number: '',
        company_name: '',
        contact_person: '',
        contact_phone: '',
        contact_website: ''
      }
    }
  },
  validations () {
    return {
      form: {
        country: {
          required
        },
        region: {
          required
        },
        email: {
          required,
          email
        },
        company_reg_number: {
          required
        },
        password1: {
          required
        },
        password2: {
          required,
          sameAsPassword: sameAs('password1')
        },
        contact_person: {
          required
        },
        contact_phone: {
          required
        },
        company_name: {
          required
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'senderRegistration',
      'receiverRegistration'
    ]),
    gettext: gettext,
    interpolate: interpolate,
    switchTabs (data) {
      this.profileType = data
    },
    validateData (item) {
      if (item) {
        if (this.$v.form.hasOwnProperty(item)) {
          this.$v.form[item].$touch()
          if (this.$v.form[item].$error) {
            this.$set(this.tooltip, item, true)
          } else if (_.has(this.errors.server, item)) {
            this.$set(this.tooltip, item, true)
          }
          setTimeout(() => {
            this.$nextTick(() => {
              this.tooltip[item] = false
            })
          }, 4000)
        } else {
          this.$set(this.tooltip, item, true)
        }
      } else {
        this.$v.$touch()
        let errors = this.$v.form
        _.each(errors, (item, key) => {
          if (!key.includes('$')) {
            if (errors[key].$error) {
              this.$set(this.tooltip, key, true)
            }
          }
        })
        setTimeout(() => {
          _.each(this.tooltip, (item, key) => {
            this.tooltip[key] = false
          })
        }, 4000)
      }
    },
    errorProcessor (error) {
      _.each(error, (item, key) => {
        if (_.has(this.form, key)) {
          this.form[key] = ''
        }
        this.$set(this.errors.server, key, item[0].message)
        this.validateData(key)
      })
      this.$v.$touch()
      this.$nextTick(() => {
        this.$scrollTo('.is-danger', 500, { container: 'body', offset: -100 })
      })
    },
    setErrorsText () {
      this.errors = {
        required: gettext('This field is required'),
        server: {}
      }
    },
    getFormData () {
      return {
        country: this.form.country.id,
        region: this.form.region.id,
        email: this.form.email,
        password1: this.form.password1,
        password2: this.form.password2,
        company_reg_number: this.form.company_reg_number,
        company_name: this.form.company_name,
        contact_person: this.form.contact_person,
        contact_phone: this.form.contact_phone,
        contact_website: this.form.contact_website,
        agree: this.agree
      }
    },
    async createAccount () {
      this.blocked = true
      this.validateData()
      if (this.profileType.sender) {
        await this.senderAccount()
      } else {
        await this.receiverAccount()
      }
      this.blocked = false
    },
    async senderAccount () {
      if (this.formIsValid) {
        await this.senderRegistration({lang: this.getLanguage, data: this.getFormData(), hook: 'registration-email-verification-company'}).then(res => {
          this.response = res
        }).catch(err => {
          try {
            if (err.data.form_errors) {
              this.errorProcessor(err.data.form_errors)
            } else if (err.data.error.data.form_errors) {
              this.errorProcessor(err.data.error.data.form_errors)
            }
          } catch (e) {
            this.response.success = false
          }
        })
      }
    },
    async receiverAccount () {
      if (this.formIsValid) {
        await this.receiverRegistration({lang: this.getLanguage, data: this.getFormData(), hook: 'registration-email-verification-company'}).then(res => {
          this.response = res
        }).catch(err => {
          try {
            if (err.data.form_errors) {
              this.errorProcessor(err.data.form_errors)
            } else if (err.data.error.data.form_errors) {
              this.errorProcessor(err.data.error.data.form_errors)
            }
          } catch (e) {
            this.response.success = false
          }
        })
      }
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    regionAction () {
      return {
        method: 'receiveRegions',
        params: {
          lang: this.getLanguage,
          country: this.form.country ? this.form.country.iso2 : '',
          sortBy: 'name'
        }
      }
    },
    companyTypeAction () {
      return {
        method: 'receiveCompanyTypes',
        params: {
          lang: this.getLanguage,
          country: this.form.country ? this.form.country.id : ''
        }
      }
    },
    defaultMetaInfo () {
      return {
        title: 'Bixter | ' + gettext('Partner registration'),
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    },
    formIsValid: function () {
      return !this.$v.$invalid
    }
  },
  created () {
    this.setErrorsText()
  }
}
</script>

<style lang='scss' src='./styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/auth/partners/index.vue